export default "/_assets/check.213164d0.svg"